<header>
    <div class="title">
        <lucide-angular name="captions" size="44"></lucide-angular>
        <h1>Transcription Editor</h1>
    </div>
</header>


<div class="video-container">
    @if(videoUrl()){
    <video #videoPlayer [controls]="false">
        <source type="video/mp4" [src]="videoUrl()">
    </video>
    }
</div>


@if(job() && originalAudio() ){
<app-transcription-visualizer [job]="job()!" [audio]="originalAudio()!"
    [transcriptionSegments]="transcriptionSegments()" (onActiveSegementChange)="activeSegement.set($event)" />
<app-transcription-segment-editor [(segment)]="activeSegement" (segmentChange)="onSegmentChange($event!)"
    (cancel)="this.activeSegement.set(undefined)" (play)="playSegment($event)" />
}

<button>valider la transcription</button>